module.exports = __webpack_public_path__ + "img/logo_minex1.9a2b5f1d.png";